export class ResetOrganisationUsersList {
  public static readonly type =
    '[Organisation/OrganisationMember/List] ResetOrganisationUsersList';
}
